import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Feature flags" hint="No flag table exists yet — propose a per-company flag store." /> }
